import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './FormDatepicker.scss';
import CustomDatePickerInput from './CustomDatePickerInput';

const FormDatepicker = (props) => {
  const { input } = props;
  const minDate = props.minDate || new Date();
  return (
    <div className="form-dropdown relative">
      <label htmlFor={props.name}>{props.label}</label>
      {props.required && <span className="form-required-text">*</span>}
      <DatePicker
        name={props.name}
        customInput={<CustomDatePickerInput />}
        selected={(input.value) ? moment(input.value, 'DD/MM/YYYY') : null}
        locale="en-nz"
        minDate={moment(minDate)}
        {...input}
      />
      {
        props.meta && props.meta.touched && props.meta.error &&
        <span className="form-validation-message">{props.meta.error}</span>
      }
    </div>
  );
};

FormDatepicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  required: PropTypes.bool,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default FormDatepicker;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormDatepicker/FormDatepicker.js
 **/